import { createRoot } from 'react-dom/client';
import './styles.css';
import { AuthProvider } from './lib/auth.jsx';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
